import styled from 'styled-components';

export const HeroStyled = styled.section`
  padding: 48px 0 0 0;
  background-color: #27252f;
  color: white;
  overflow: hidden;

  @media screen and (min-width: 992px) {
    padding: 209px 0 120px;
  }
`;

export const Button = styled.a`
  width: 100%;
  display: block;

  &.white {
    box-shadow: inset 0 0 0 1px #fff;
    color: white;
    transition: all 0.2s ease;

    &:hover,
    &:focus,
    &:active {
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.7);
      color: rgba(255, 255, 255, 0.7);
      transition: all 0.2s ease;
    }
  }

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  @media screen and (min-width: 992px) {
    display: inline-block;
    width: auto;
    margin-bottom: 0;
    &:not(:last-child) {
      margin: 0 24px 0 0;
    }
  }
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  justify-content: center;

  @media screen and (min-width: 992px) {
    justify-content: flex-start;
    margin-bottom: 32px;
  }

  img {
    @media screen and (min-width: 992px) {
      margin-right: 25px;
    }
  }

  h2 {
    display: none;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 23.4px;
    color: #ffffff;

    @media screen and (min-width: 992px) {
      display: inline-block;
    }
  }
`;

export const TextHeader = styled.div`
  @media screen and (min-width: 992px) {
    grid-column: 2 / 8;
  }
`;

export const Headline = styled.h1`
  margin-bottom: 32px;
  font-size: 32px;
  line-height: 1.3;
  text-align: center;
  color: #ffffff;

  @media screen and (min-width: 992px) {
    margin-bottom: 40px;
    font-size: 40px;
    color: #ffffff;
    text-align: left;
  }
`;

export const HighLightText = styled.p`
  margin-bottom: 32px;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #b7b7b7;
  max-width: 100%;

  @media screen and (min-width: 992px) {
    margin-bottom: 50px;
    font-size: 20px;
    line-height: 34px;
    text-align: left;
    max-width: 80%;
  }
`;

export const ImageBlock = styled.figure`
  margin-top: 40px;
  margin-bottom: 88px;
  max-height: 61vw;

  @media screen and (min-width: 992px) {
    margin-bottom: 0;
  }

  img {
    display: block;
    max-width: 400px;
    margin: 0 auto;
    width: 100%;
}

    @media screen and (min-width: 992px) {
      max-width: 100%;
    }
  }

  video {
    display: none;

    &::-webkit-media-controls {
      display: none;
    }

    .custom-video-controls {
      z-index: 2147483647;
    }
  }

  @media screen and (min-width: 992px) {
    grid-column: 8 / 13;
    margin-top: 0;
    max-height: initial;
    position: relative;

    img {
      display: none;
    }

    video {
      display: inline-block;
      max-width: 600px;
      margin-left: -65px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Hero/styled.js